import type { ReportEntry } from '../../../types/report.js';

export const FILTERABLE_COLUMNS = ['campaignName', 'adGroupName', 'keywordName'] as const;

export type FilterableColumn = (typeof FILTERABLE_COLUMNS)[number];

export type ColumnFilters = Record<FilterableColumn, string[]>;

export const createEmptyColumnFilters = (): ColumnFilters => ({
  campaignName: [],
  adGroupName: [],
  keywordName: [],
});

const NULL_FILTER_VALUE = '__NULL__';

export const encodeFilterValue = (value?: string | null): string => {
  if (typeof value === 'string' && value.trim().length > 0) {
    return value;
  }
  return NULL_FILTER_VALUE;
};

export const getLabelForFilterValue = (value?: string | null): string =>
  typeof value === 'string' && value.trim().length > 0 ? value : '—';

export const getLabelForEncodedFilterValue = (encoded: string): string =>
  encoded === NULL_FILTER_VALUE ? '—' : encoded;

const isFilterActive = (values?: string[]) => !!values && values.length > 0;

export const matchesColumnFilter = (value: string | null | undefined, filterValues: string[]): boolean => {
  if (!isFilterActive(filterValues)) {
    return true;
  }
  const encoded = encodeFilterValue(value);
  return filterValues.includes(encoded);
};

export const entryMatchesFilters = (
  entry: ReportEntry,
  filters: ColumnFilters,
  columns: FilterableColumn[] = [...FILTERABLE_COLUMNS]
): boolean =>
  columns.every((column) => matchesColumnFilter(entry.group[column], filters[column]));
